import { render, staticRenderFns } from "./TabApplication.vue?vue&type=template&id=01ab6220&scoped=true"
import script from "./TabApplication.vue?vue&type=script&lang=js"
export * from "./TabApplication.vue?vue&type=script&lang=js"
import style0 from "./TabApplication.vue?vue&type=style&index=0&id=01ab6220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ab6220",
  null
  
)

export default component.exports